import './CallToActionLanding.css';

const CallToActionLanding = () => {
   return (
      <section className="landing-page-cta">
        <div className="cta-container">
            <h2>Ready to Transform Your Logistics?</h2>
            <p>Join the companies who have already optimized their transportation operations with Freight Ops.</p>
            <div className="cta-links-container">
                <a href="/tms/login" className="cta-button"
                  target="_blank" rel="noopener noreferrer"
                >
                  Get Started
                </a>
                <a href="/contact" className="secondary-button"
                  target="_blank" rel="noopener noreferrer"
                >
                  Schedule Demo
                </a>
            </div>
        </div>
      </section>
   );
};

export default CallToActionLanding;
